
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/iframe/[tour]",
      function () {
        return require("private-next-pages/iframe/[tour]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/iframe/[tour]"])
      });
    }
  